export enum DoctorConstants {
    DOCTOR_ME = 'DOCTOR/ME',
}
